module.exports = __webpack_public_path__ + "static/Grupo 79-17318917835b67693988e484e2ea9903.svg";